$(document).ready(function () {
  addCustomerLogos();

  $('.customer-filters li').click(function (e) {
    e.preventDefault();

    if ($('.customer-filters li.active').length == $('.customer-filters li').length) {
      $('.customer-filters li.active').removeClass('active');
      $('.customer_logos .customer.active').removeClass('active');
      $('.customer_logos .customer[data-category="' + $(this).attr('data-category') + '"').addClass('active');
      $(this).addClass('active');
    } else {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.customer_logos .customer[data-category="' + $(this).attr('data-category') + '"').removeClass('active');
      } else {
        $(this).addClass('active');
        $('.customer_logos .customer[data-category="' + $(this).attr('data-category') + '"').addClass('active');
      }

      if ($('.customer-filters li.active').length == 0) {
        $('.customer-filters li').addClass('active');
        $('.customer_logos .customer').addClass('active');
      }
    }


  });

});

function addCustomerLogos() {
  let customers = [
    {"category": "solar", "name": "astra-solar"},
    {"category": "solar", "name": "cosco-shipping"},
    {"category": "solar", "name": "longi"},
    {"category": "packaging", "name": "berry"},
    {"category": "packaging", "name": "bpi-formipac"},
    {"category": "packaging", "name": "ds-smith"},
    {"category": "packaging", "name": "europal-packaging"},
    {"category": "construct", "name": "betafence"},
    {"category": "construct", "name": "cebeo"},
    {"category": "construct", "name": "gardival"},
    {"category": "construct", "name": "isomo"},
    {"category": "construct", "name": "joris-ide"},
    {"category": "construct", "name": "knauf"},
    {"category": "construct", "name": "lalegno"},
    {"category": "construct", "name": "sonepar"},
    {"category": "construct", "name": "stow"},
    {"category": "construct", "name": "unilin"},
    {"category": "construct", "name": "vascogroup"},
    {"category": "waste", "name": "groupe-comet"},
    {"category": "waste", "name": "recupal-west"},
    {"category": "waste", "name": "vanheede"},
    {"category": "retail", "name": "bama"},
    {"category": "retail", "name": "cocacola"},
    {"category": "retail", "name": "extra"},
    {"category": "retail", "name": "frieslandcampina"},
    {"category": "retail", "name": "gb-foods"},
    {"category": "retail", "name": "hubo"},
    {"category": "retail", "name": "leroy-merlin"},
    {"category": "retail", "name": "lidl"},
    {"category": "retail", "name": "mulder"},
    {"category": "retail", "name": "my-ohgreen"},
    {"category": "retail", "name": "ontex"},
    {"category": "retail", "name": "paradiso-toys"},
    {"category": "retail", "name": "pfuk"},
    {"category": "retail", "name": "poco-loco"},
    {"category": "retail", "name": "pvg"},
    {"category": "retail", "name": "soubry"},
    {"category": "retail", "name": "tropicana"},
    {"category": "retail", "name": "versele-laga"},
    {"category": "steel", "name": "boal"},
    {"category": "steel", "name": "buysmetal"},
    {"category": "steel", "name": "emax"},
    {"category": "steel", "name": "klockner-co"},
    {"category": "steel", "name": "reynaers"},
    {"category": "steel", "name": "sadef"},
    {"category": "steel", "name": "sapa"},
    {"category": "steel", "name": "van-heyghen-staal"},
    {"category": "industrial", "name": "acd"},
    {"category": "industrial", "name": "caterpillar"},
    {"category": "industrial", "name": "meura"},
    {"category": "industrial", "name": "jungheinrich"},
    {"category": "industrial", "name": "solar-turbines"},
    {"category": "industrial", "name": "td-williamnson"},
    {"category": "industrial", "name": "team-industries"},
    {"category": "industrial", "name": "vynckier"},
    {"category": "chem", "name": "ecochem"},
    {"category": "chem", "name": "goodmark"},
    {"category": "chem", "name": "ineos"},
    {"category": "chem", "name": "italmatch-chemicals"},
    {"category": "chem", "name": "vitafor"},
    {"category": "chem", "name": "westfalen"},
    {"category": "chem", "name": "yara"},
    {"category": "ecom-publi", "name": "bd"},
    {"category": "ecom-publi", "name": "bpost"},
    {"category": "ecom-publi", "name": "roularta-media-group"},
  ];

  shuffleArray(customers);
  let numRows = 5;
  let numItemsInRow = Math.ceil(customers.length / 5);
  let row_counter = 1;
  let row_item_counter = 0;

  // Insert logos - Start

  $.each(customers, function (i, customer) {
    if (row_item_counter >= numItemsInRow) {
      row_counter++;
      row_item_counter = 0;
    }

    if (row_item_counter == 0) {
      $('.customer_logos').append("<div class='row row-" + row_counter + "'><div class='row__inner'></div></div>");
    }

    let random_delay = getRandomBetween(0.0, 0.8).toFixed(2);
    $('.customer_logos').find('.row-' + row_counter).find('.row__inner').append("<a href='#dialog-content' class='customer active lightbox' style='transition-delay: " + random_delay + "s !important;' data-category='" + customer.category + "'><div class='customer__inner'><img src='../dist/img/logos/" + customer.category + "/" + customer.name + ".png' /></div></a>");
    row_item_counter++;
  });

  setTimeout(function(){
    $('.customer').addClass('init');
  }, 100);


  // Insert logos - End

  // Duplicate rows

  $('.customer_logos').find('.row').each(function () {
    $(this).append($(this).find('.row__inner').first().clone());
    $(this).append($(this).find('.row__inner').first().clone());
    $(this).append($(this).find('.row__inner').first().clone());
    $(this).append($(this).find('.row__inner').first().clone());
  });

}

// Functie om array door elkaar te schudden
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function getRandomBetween(min, max) {
  return Math.random() * (max - min) + min;
}
